import React from 'react'
import { SurfPlanningLinks } from '../../components/surf-planning/surf-planning.component'
import { SURF_ARTICLE_SLUGS } from '../../lib/surf-seo.mjs'
import ArticleLayout from '../../components/article-layout/article-layout.component'
import { getClient } from '../../client'
import {
  sanitySrcUrl,
  groqAllBlogPostsQuery,
  groqBlogPostBySlugQuery,
} from '../../lib/libFunctions'
import { buildArticle, buildBlogBreadcrumb } from '../../lib/structuredData'
import { siteUrl } from '../../lib/companyInfo'
import { applyListingExclusionsToPost } from '../../lib/listing-exclusions.mjs'
import { applyPublicCopyCorrectionsToPost } from '../../lib/public-copy-corrections.mjs'
import { applySooklaRestaurantGuideAddition } from '../../lib/sookla-guide-addition.mjs'

export default function BlogPost({ post }) {
  const url = `${siteUrl}/blog/${post.slug?.current || ''}`
  const jsonLd = [
    buildArticle(post, url, post.mainImage ? sanitySrcUrl(post.mainImage) : undefined),
    buildBlogBreadcrumb(post, url),
  ]
  return <ArticleLayout doc={post} seo={post.seo} jsonLd={jsonLd} variant="article" afterBody={SURF_ARTICLE_SLUGS.includes(post.slug?.current) ? <SurfPlanningLinks moduleId={post._id} /> : null} />
}

export async function getStaticPaths() {
  const posts = await getClient().fetch(groqAllBlogPostsQuery())
  const paths = posts
    .filter((post) => post.slug && post.slug.current)
    .map((post) => ({ params: { slug: post.slug.current } }))
  // Use blocking fallback so newly published posts resolve on first request
  return { paths, fallback: 'blocking' }
}

export async function getStaticProps({ params }) {
  const { slug } = params
  const post = await getClient().fetch(groqBlogPostBySlugQuery(slug))
  if (!post) {
    return { notFound: true }
  }

  return {
    props: { post: applySooklaRestaurantGuideAddition(applyPublicCopyCorrectionsToPost(applyListingExclusionsToPost(post))) },
    // Allow ISR so new content appears without a full rebuild
    revalidate: 60,
  }
}
